import { render, staticRenderFns } from "./backtotop.vue?vue&type=template&id=3ed00a8e&"
import script from "./backtotop.vue?vue&type=script&lang=js&"
export * from "./backtotop.vue?vue&type=script&lang=js&"
import style0 from "./backtotop.vue?vue&type=style&index=0&id=3ed00a8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports